function shareApp() {
  var shareBts = [];
  var shares = null;
  plus.share.getServices(function(s){
    shares={};
    for(var i in s){
        var t=s[i];
        shares[t.id]=t;
    }
    var ss = shares["weixin"];
  ss && ss.nativeClient &&
    (shareBts.push({ title: "微信朋友圈", s: ss, x: "WXSceneTimeline" }),
    shareBts.push({ title: "微信好友", s: ss, x: "WXSceneSession" }));
  /*ss = shares["qq"];
  ss && ss.nativeClient && shareBts.push({ title: "QQ", s: ss });*/
  // 弹出分享列表
  shareBts.length > 0
    ? plus.nativeUI.actionSheet(
        { title: "分享链接", cancel: "取消", buttons: shareBts },
        function(e) {
            if(e.index > 0){
                var sb = shareBts[e.index - 1];
                 var msg = { extra: { scene: sb.x } };
                msg.href = "https://m.ihotel.cn?type=mihotel";
                msg.title = "邀请你一起体验MiHotel";
                msg.content ="全新改版的界面风格，全新的用户体验，为你提供更高效的操作";
                msg.thumbs = ["_www/static/images/logo.png"];
                msg.pictures = ["_www/static/images/logo.png"];
                if (sb.s.authenticated) {
                    shareMessage(msg, sb.s);
                } else {
                console.log("---未授权---");
                sb.s.authorize(
                function() {
                    shareMessage(msg, sb.s);
                },
                function(e) {
                    showMsg("认证授权失败：" + e.code + " - " + e.message);
                }
                );
            }
            }
        }
      )
    : showMsg("当前环境无法支持分享链接操作!");
}, function(e){
    showMsg('获取分享服务列表失败：'+e.message);
});
}
function showMsg(msg){
    plus.nativeUI.toast(msg);
}
function shareMessage(msg, s) {
  s.send(
    msg,
    function() {
        showMsg('分享成功！');
    },
    function(e) {
        console.log(JSON.stringify(e));
        showMsg('分享失败');
    }
  );
}
export { 
    shareApp
}


// WEBPACK FOOTER //
// ./src/assets/js/share.js